import { render } from "./manage_users.vue?vue&type=template&id=ebeda5ca"
import script from "./manage_users.vue?vue&type=script&lang=js"
export * from "./manage_users.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__